import React, { useEffect } from 'react';
import ZKBridgeApp from './components/ZKBridgeApp';
import WagmiAppProvider from './providers/WagmiProvider';
import { initPostHog } from './config/posthog';
import './index.css';

function App() {
  // Initialize PostHog on app load
  useEffect(() => {
    initPostHog();
  }, []);

  return (
    <WagmiAppProvider>
      <div className="App">
        <ZKBridgeApp />
      </div>
    </WagmiAppProvider>
  );
}

export default App;
